export default "__VITE_ASSET__6a1ad8d9__"